import {setXhrCache} from '@/helper/XhrCache';

export default function ({$xhrCache}) {
  setXhrCache($xhrCache);
}
